export const ApplicationKeyList = [
    {
        id: 0,
        enviroment: "Production",
        baseUri: "https://connect.calamp.co.uk/",
        jasperConnect: 'CONNECT_AWS',
        name: "Insurance Telematics Portal - UK",
        key: "ed8f8118-483e-4ac6-aa6f-18d610f5a594"
    }
];
export const appDebug = false;
export const crashBoxxWebApiBaseUri = "https://itpapi.connect.calamp.co.uk/";
export const jasperBaseCrashBoxxReportUrl = "https://reporting.calamp.co.uk/jasperserver-pro/dashboard/viewer.html?sessionDecorator=no&viewAsDashboardFrame=true&dashboardResource=/public/CONNECT/Dashboards/Crashboxx_Dashboard&Select_Interval=6";
export const googleTimeZoneAPIKey = "AIzaSyA_cvUbLfFFYLBCTKXAAO9epFVLu3iAAsA";
export const googleMapApiKey = "AIzaSyCtOcF4F3nbbNDThxPrTnCnvG7sXwgBhwg";
export const googleMapUrl = "https://maps.google.com/maps/api/js?libraries=geometry&key=AIzaSyCtOcF4F3nbbNDThxPrTnCnvG7sXwgBhwg";
export const baseName = "";
export const googleAnalyticsKey = "UA-89391912-1";

// lista di utenti che possono modificare l'event classification dell'ICN
export const EventClassificationUsers = [
    "scaratozzolo",
    "pdevito",
    "cbx_user_QA",
    "cbx_user_IT",
    "cbx_user_CT",
    "us_cbx_user",
    "Cbx_user_UK",
    "cbx_user_UK",
    "UK_cbx_user",
    "uk_cbx_user",
    "usr_cc",
    "Ryann",
    "Skale",
    "ryann",
    "skale"
];

// users who can access  PredictivePhysicalDamageV2
export const PredictivePhysicalDamageV2Users = [
    'spulligadda_crashboxx',
    'qa_spuligadda_root',
    'ljiadmin',
    'cbx_spuligadda',
    'pdevito'
];


// WEBPACK FOOTER //
// ./src/settings/settings.prod.UK.js